/**
 * @file TermsAndConditionsView.jsx
 * @author Daniel Aguirre
 * @description Terms and Conditions View Page
 */

// Dependencies
import AppCardLayout from 'components/AppCardLayout';
import React from 'react';

import { termsAndConditions } from '@nephro/commons/helpers/string-helper';

function TermsAndConditionsView() {
  return (
    <AppCardLayout>
      <div className="text-baxterGray py-4 px-10">
        <section>
          <td
            dangerouslySetInnerHTML={{
              __html: termsAndConditions
            }}
          />
        </section>
      </div>
    </AppCardLayout>
  );
}

export default TermsAndConditionsView;
